import { useTranslation } from "react-i18next";
import { Text } from "@/components/Text";
import { DraftCard } from "./DraftCard";
import type { EntityDraftCardProps } from "./registry";

/** A draft of a type this client has no card for: its fields, read-only, so the thread never breaks. */
export function GenericDraftCard({ draft, state, answerable }: Readonly<EntityDraftCardProps>) {
  const { t } = useTranslation("buildChat", { keyPrefix: "draft" });
  const name = typeof draft.draft.name === "string" && draft.draft.name ? draft.draft.name : t("untitled");
  return (
    <DraftCard
      title={name}
      entityLabel={t("entityFallback", { type: draft.entityType })}
      state={state}
      missingFields={draft.missingFields}
      questions={draft.questions}
      answerable={answerable}
      busy={false}
      summary={
        <pre className="max-h-64 overflow-auto whitespace-pre-wrap break-words">
          <Text variant="code" tone="secondary">
            {JSON.stringify(draft.draft, null, 2)}
          </Text>
        </pre>
      }
    />
  );
}
